import { page } from '@stereoagency/sanity-schema';

export const pageByIdQuery = page.schema.builder
  .filter('_id == $id')
  .pick(['_id', 'sections', 'pattern'])
  .first()
  .use();
